import CuratorApplicationForm from "../../components/curator/CuratorApplicationForm";

export default function Apply() {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f6f1]">
      <CuratorApplicationForm user={user} />
    </div>
  );
}